import type { AdResolutionFontDescriptor } from './types';
import type { FontFace as AdflowFontFace } from '@adflow/types';

/** Stable empty references — avoid new [] each render (font loader effect loop). */
export const EMPTY_RESOLUTION_FONTS: readonly AdResolutionFontDescriptor[] = [];
export const EMPTY_FONT_FACES: readonly AdflowFontFace[] = [];
